import { IssuesTab } from "@/organisms/Drawers/components/IssuesTab"
import {
  getDefaultFiltersInventoryImageIssuesDrawer,
  getDefaultParamsOpenSourceIssue
} from "@/organisms/Drawers/hooks/useParamsFilter"

import { buildQueryStringFromRecord } from "@/helpers/filters.helper"

import type { IssueTabApplicationDrawerComponent } from "."

export const IssueTabApplicationDrawer: IssueTabApplicationDrawerComponent = (
  props
) => (
  <IssuesTab
    getInitialParamsFilter={getDefaultFiltersInventoryImageIssuesDrawer}
    defaultParams={getDefaultParamsOpenSourceIssue()}
    exportQueryParams={(params: Record<string, any>) =>
      buildQueryStringFromRecord({ resourceId: props.record?.id, ...params })
    }
    {...props}
  />
)
